<template>
    <form :class="{ 'form-signin': true}">

      <input
          :value="input"
          type="hidden"
          class="input"
          placeholder="Tap on the virtual keyboard to start"
      >

      <SimpleKeyboard @onChange="onChange" @onKeyPress="onKeyPress" :input="input"/>

    </form>
</template>

<script>
    import SimpleKeyboard from "../views/SimpleKeyboard";

    export default {
        props: ['disabled'],
        components: {
          SimpleKeyboard
        },
        data() {
            return {
                input: '',
                processing: false,
                error: null,
                success: null
            }
        },

        methods: {
            onChange(input) {
              this.input = input;
              window.events.$emit('numpadValue', input);
            },
            onKeyPress(value) {
              this.$store.dispatch('clearErrors');
              if (value === "{shift}" || value === "{lock}") {
                this.switchScreen();
              } else if (value === '{bksp}') {
                this.clearInput();
              } else if (value === '{enter}') {
                this.submit();
              } else {
               this.type(value);
              }

            },
            type(value) {
              window.events.$emit('numpadType', value);
            },

            clearInput() {
                window.events.$emit('backspace')
            },

            switchScreen () {
                document.querySelector('.app').classList.toggle('app--switched')
            },

            numpadType (event) {
                if(document.activeElement.id !== 'pin') {
                    if (event.keyCode === 48 || event.keyCode === 96) { this.type(0) }
                    if (event.keyCode === 49 || event.keyCode === 97) { this.type(1) }
                    if (event.keyCode === 50 || event.keyCode === 98) { this.type(2) }
                    if (event.keyCode === 51 || event.keyCode === 99) { this.type(3) }
                    if (event.keyCode === 52 || event.keyCode === 100) { this.type(4) }
                    if (event.keyCode === 53 || event.keyCode === 101) { this.type(5) }
                    if (event.keyCode === 54 || event.keyCode === 102) { this.type(6) }
                    if (event.keyCode === 55 || event.keyCode === 103) { this.type(7) }
                    if (event.keyCode === 56 || event.keyCode === 104) { this.type(8) }
                    if (event.keyCode === 57 || event.keyCode === 105) { this.type(9) }

                    if (event.keyCode === 8) { this.clearInput() }
                }
            },

            submit () {
                window.events.$emit('submitFromNumpad')
            }
        },

        mounted() {
            window.addEventListener('keyup', this.numpadType);
            window.events.$on('enableNumpad', value => {
                console.log('enableNumpad from NumPad!');
                this.$nextTick(() => {
                  this.input='';
                })
            });
        },

        beforeDestroy () {
            window.removeEventListener('keyup', this.numpadType)
        },

    }
</script>
